import {
  Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges,
  ViewChild, AfterViewInit, EventEmitter, Output, ElementRef, Renderer2
} from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from 'app/shivam/login/login.service';
import { LoginFormService } from './login-form.service';
import { AuthenticationService } from 'app/shivam/shared/auth/authentication.service';
import { CurrentUser } from 'app/shivam/model/current-user';
import { AFTER_LOGIN_ACTION } from 'app/shivam/model/login-enum';
import { WindowRefService } from 'app/shivam/added-pooja-list/WindowRef.service';
import { NgIf, NgFor, NgSwitch, NgSwitchCase } from '@angular/common';
import { IntlTelInputComponent } from '../../intl-tel-input/intl-tel-input.component';

import { CounterDirective } from 'utils/directives/counter/counter.directive';
import { ToasterService } from 'app/shivam/services/toaster.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  imports: [NgIf, FormsModule, ReactiveFormsModule, NgFor, NgSwitch, NgSwitchCase, IntlTelInputComponent, CounterDirective]
})
export class LoginFormComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @ViewChild('otpInput') otpInput!: ElementRef;
  loginForm: UntypedFormGroup;
  isUserNamePassword = false;
  hideOrShowPassword = true;
  componentDestroySubject = new Subject();
  loading = false;
  submitted = false;
  @Output() submitForOTPVerify = new EventEmitter();
  @Output() socialLogin = new EventEmitter<string>();
  @Output() openTerms = new EventEmitter<void>();
  @Output() openPrivacy = new EventEmitter<void>();
  @Input() mobileNumber = '';
  @Input() isAfterSocioLogin = false;
  useralreadyExist = false;
  formControls = ['mobileNumber'];
  isOtpLogin: boolean;
  isOtpVerify: boolean;
  isOtpRegister: boolean;
  isEditMobileNo: boolean;
  isMobileAndPassword: boolean;
  existingUsername: any;
  counterValue = 0;
  countFinished = false;
  windowRef: any;
  @ViewChild('recaptchaContainer', { static: false }) recaptchaContainerRef: ElementRef;
  constructor(private win: WindowRefService, private fb: UntypedFormBuilder, private loginService: LoginService,
    public authService: AuthenticationService, private renderer: Renderer2,
    private toastr: ToasterService,
    private loginFormService: LoginFormService) {
    this.loginForm = this.fb.group({});
    this.formControls.forEach((e) => {
      this.windowRef = this.win.nativeWindow;

      this.loginForm.addControl(e, new UntypedFormControl('', Validators.required))
    })
  }
  ngOnInit() {
    // this.userNameChangeListener();

  }
  ngAfterViewInit() {
    // this.otpErrorListener()

  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.mobileNumber?.currentValue) {
      this.loginForm.controls.mobileNumber.setValue(this.mobileNumber);
    }
  }
  // otpErrorListener() {
  //   this.authService.otpError.subscribe((error: any) => {
  //     this.submitted = true;
  //     this.loginForm.controls.otp.setErrors({ invalidOTP: true })

  //   })
  // }
  resendOtp() {
    this.loginFormService.mobileNumber = this.mobileNumber;
    this.countFinished = false;
    this.loginFormService.loadCapthaVerifier();
    this.loginForm.controls.otp.setErrors({ invalidOTP: false })
  }
  userNameChangeListener() {
    const controls = this.loginForm.controls;

    controls.userName.valueChanges.pipe(takeUntil(this.componentDestroySubject)).subscribe((username) => {
      this.useralreadyExist = false;
    })
  }
  get currentUser() {
    const currentUser: CurrentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser;
  }
  submit() {
    this.existingUsername = '';
    if (this.loginForm.invalid) {
      this.submitted = true;
      return;
    }

    if (!this.isUserNamePassword) {
      this.submitted = false;

      if (this.loginForm.controls.otp?.value) {
        if (this.isOtpVerify) {
          this.authService.verifyOTPLogin(this.loginForm.value);

          return;
        }
        if (this.isOtpRegister) {

          this.authService.verifyOTPLogin(this.loginForm.value, true);

          return;
        }
        if (this.useralreadyExist && this.isOtpLogin) {
          if (this.loginFormService.windowRef.recaptchaVerifier) {
            this.authService.verifyOTPLogin(this.loginForm.value, true);
            return;
          }
        }
        if (this.isOtpLogin) {
          if (this.loginFormService.windowRef.recaptchaVerifier) {
            this.authService.verifyOTPLogin(this.loginForm.value);
            return;
          }
        }
      }
      if (this.useralreadyExist && this.isMobileAndPassword) {
        this.loading = true;
        this.loginService.login({
          mobileNumber: this.mobileNumber,
          password: this.loginForm.controls.password.value
        }).subscribe(response => {
          if (response.status === 'SUCCESS') {
            localStorage.setItem('currentUser', JSON.stringify(response.result));
            if (response.result.emailVerification !== 'true' && !response.result.email) {
              this.authService.afterSocioLogin.next(AFTER_LOGIN_ACTION.EMAIL_VERIFICATION);
            } else {
              this.authService.loginCompleted.next('SUCCESS');
            }
          }
          // if (!!response) {
          this.loading = false;
          // }
        });

        return;
      }
      const controls = this.loginForm.controls;
      if (this.formControls.includes('name') && this.formControls.includes('otp')) {
        this.authService.verifyOTPLogin(this.loginForm.value);
      }
      if (!this.isEditMobileNo) {
        this.loginService.phoneNumberVerified(controls.mobileNumber.value).subscribe((response) => {
          if (response.status === 'FAILED') {
            return;
          }
          this.loginFormService.mobileNumber = controls.mobileNumber.value;
          this.mobileNumber = controls.mobileNumber.value;
          this.isEditMobileNo = true;
          if (response.result) {
            if (response.result.verified) {
              this.addControls(['otp']);
              this.removeControls(['mobileNumber']);
              this.existingUsername = response.result.name
              this.isOtpRegister = false;
              this.isOtpLogin = true;
              this.useralreadyExist = true;
              this.isOtpVerify = false;
              this.isMobileAndPassword = false;
              this.loginFormService.loadCapthaVerifier();
              this.focusOtpInput();
            }

          } else {
            if (this.currentUser?.email) {
              this.addControls(['otp']);
              this.removeControls(['mobileNumber']);
              this.isOtpVerify = true;
              this.isMobileAndPassword = false;
              this.isMobileAndPassword = false;
            } else {
              this.addControls(['name', 'otp']);
              this.removeControls(['mobileNumber']);
              this.isOtpRegister = true;
              this.isOtpLogin = false;
              this.isOtpVerify = false;
              this.isMobileAndPassword = false;

            }
            this.loginFormService.loadCapthaVerifier();
            this.focusOtpInput();
          }

        })
      } else {
        this.loginFormService.mobileNumber = this.mobileNumber;
        this.loginFormService.loadCapthaVerifier();
        this.focusOtpInput();
      }
      return;
    }
    this.submitted = false;
    this.loading = true;
    this.loginService.login(this.loginForm.value).subscribe(response => {
      if (response.status === 'SUCCESS') {

        localStorage.setItem('currentUser', JSON.stringify(response.result));
        if (response.result.emailVerification !== 'true' && !response.result.email) {
          this.authService.afterSocioLogin.next(AFTER_LOGIN_ACTION.EMAIL_VERIFICATION);
        } else {
          this.authService.loginCompleted.next('SUCCESS');
        }
      }
      // if (!!response) {
      this.loading = false;
      // }
    });

  }
  phoneNumberAlreadyExist() {
    const controls = this.loginForm.controls;
    controls.userName.setValidators(null);
    controls.password.updateValueAndValidity({ emitEvent: false });
  }
  addControls(formControls: string[]) {
    this.formControls = [...new Set(this.formControls.concat([...formControls]).map(e => e))];

    formControls.forEach((e) => {
      this.loginForm.addControl(e, new UntypedFormControl('', Validators.required))
    })

  }
  removeControls(formControls: string[]) {
    this.formControls = this.formControls.filter(e => !formControls.includes(e))
    formControls.forEach(e => { this.loginForm.removeControl(e); });

  }
  focusOtpInput() {
    setTimeout(() => {
      if (this.otpInput && this.otpInput.nativeElement) {
        this.otpInput.nativeElement.focus();
      }
    }, 150);
  }
  onSecondaryLoginClick() {
    this.existingUsername = '';
    this.isUserNamePassword = !this.isUserNamePassword;
    const controls = this.loginForm.controls;
    this.isOtpLogin = false;
    this.isOtpVerify = false;
    this.isOtpRegister = false;
    this.submitted = false;
    this.formControls = [];
    if (this.isUserNamePassword) {
      this.isMobileAndPassword = false;
      this.isOtpLogin = false;
      this.removeControls(['otp', 'name', 'mobileNumber']);
      this.addControls(['userName', 'password']);


    } else {
      this.isMobileAndPassword = false;
      this.isOtpLogin = false;
      this.removeControls(['userName', 'password']);
      this.addControls(['mobileNumber']);

    }
    this.useralreadyExist = false;
    this.isEditMobileNo = false;
    this.submitForOTPVerify.emit({ action: 'LOGIN', mobileNumber: controls.mobileNumber?.value })
  }
  onOtpClick() {
    this.isOtpLogin = !this.isOtpLogin;
    const controls = this.loginForm.controls;
    let child = this.recaptchaContainerRef.nativeElement.children[0];
    if (!this.isOtpLogin) {
      this.removeControls(['otp'])
      this.addControls(['password']);
      this.isMobileAndPassword = true;
      this.windowRef.recaptchaVerifier.clear();

      this.renderer.removeChild(this.recaptchaContainerRef.nativeElement, child)
      this.windowRef.recaptchaVerifier = null;


    } else {
      this.removeControls(['password']);
      if (!child) {
        child = this.renderer.createElement('div');
        this.renderer.setAttribute(child, 'id', 'recaptcha-container')
        this.renderer.appendChild(this.recaptchaContainerRef.nativeElement, child)
      }
      this.addControls(['otp']);
      this.loginFormService.mobileNumber = this.mobileNumber;
      this.loginFormService.loadCapthaVerifier();
      this.isMobileAndPassword = false;


    }

  }

  editMobileNumber() {
    this.existingUsername = '';
    this.isEditMobileNo = false;
    this.addControls(['mobileNumber']);
    this.loginForm.controls.mobileNumber.setValue(this.mobileNumber)
    this.removeControls(['otp', 'name', 'password']);
    this.isOtpVerify = false;
    this.isOtpRegister = false;
    this.isUserNamePassword = false;
    this.isOtpLogin = false;
    this.useralreadyExist = false;
    this.isMobileAndPassword = false;
  }
  ngOnDestroy(): void {
    this.componentDestroySubject.next(true);
    this.windowRef.recaptchaVerifier = null;


  }


  dismiss() {
    if (!this.loading) {
      // this.activeModal.dismiss();
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser) {
        this.authService.loginCompleted.next('SUCCESS')
      }

    }
  }
  signInAnonymously(): void {
    this.mobileNumber = '';
    this.authService._signInAnonymously('pooja-booking');
  }

  onSocialLogin(provider: string) {
    this.socialLogin.emit(provider);
  }
}
